function readMessage(value: unknown): string | null {
  if (!value || typeof value !== "object") {
    return null;
  }

  const message = (value as { message?: unknown }).message;
  return typeof message === "string" && message.trim() ? message.trim() : null;
}

export function extractApiSuccessMessage(data: unknown): string | null {
  if (!data || typeof data !== "object") {
    return null;
  }

  const record = data as Record<string, unknown>;
  const success = record.success;

  if (success && typeof success === "object") {
    const successMessage = readMessage(success);
    if (successMessage) {
      return successMessage;
    }
  }

  if (typeof record.message === "string" && record.message.trim()) {
    return record.message.trim();
  }

  return null;
}

export function extractApiErrorMessage(data: unknown): string | null {
  if (!data) {
    return null;
  }

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (typeof data !== "object") {
    return null;
  }

  const record = data as Record<string, unknown>;

  if (typeof record.message === "string" && record.message.trim()) {
    return record.message.trim();
  }

  const error = record.error;

  if (Array.isArray(error)) {
    const messages = error
      .map(item => readMessage(item))
      .filter((message): message is string => Boolean(message));

    if (messages.length > 0) {
      return messages.join(", ");
    }
  }

  if (error && typeof error === "object") {
    const nestedMessage = readMessage(error);
    if (nestedMessage) {
      return nestedMessage;
    }
  }

  if (typeof error === "string" && error.trim()) {
    return error.trim();
  }

  return null;
}

export function getApiErrorMessage(
  error: unknown,
  fallback = "Something went wrong. Please try again."
): string {
  if (error && typeof error === "object" && "response" in error) {
    const responseData = (error as { response?: { data?: unknown } }).response
      ?.data;
    const apiMessage = extractApiErrorMessage(responseData);
    if (apiMessage) {
      return apiMessage;
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message.trim();
  }

  return fallback;
}
